import React from 'react';
import { token } from '@atlaskit/tokens';
import SectionMessage from '@atlaskit/section-message';
import ButtonLink from 'components/common/ButtonLink';
import { styled } from 'styled-components';
import { Dimensions } from 'components/visuals';
import t from 'modules/i18n/intl';
import { messages } from '../messages';
import { DcAppParentMappingUploadResult } from '../duck/api/fetchDcAppParentMapping';

const WarningWrapper = styled.div`
  margin: ${Dimensions.units(1.5)}px 0;
`;

const FailedMappingsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: ${Dimensions.units(1.5)}px 0;
`;

const Th = styled.th`
  text-align: left;
  padding: ${Dimensions.units(1)}px;
  border-bottom: 1px solid ${token('color.border', '#B3B9C4')};
`;

const Td = styled.td`
  padding: ${Dimensions.units(1)}px;
  border-bottom: 1px solid ${token('color.background.neutral', '#F1F2F4')};
  vertical-align: top;
`;

type Props = {
  uploadResult: DcAppParentMappingUploadResult;
  onDownloadFailed: () => void;
};

const DcAppParentMappingUploadWarning = ({ uploadResult, onDownloadFailed }: Props) => {
  if (!uploadResult || uploadResult.failureCount <= 0) {
    return null;
  }

  return (
    <WarningWrapper>
      <SectionMessage appearance="warning">
        <p>
          <strong>{t(messages.dcAppParentMappingUploadWarningTitle)}</strong>
        </p>
        <FailedMappingsTable>
          <thead>
            <tr>
              <Th>{t(messages.dcAppParentMappingUploadWarningTableAppAccountId)}</Th>
              <Th>{t(messages.dcAppParentMappingUploadWarningTableParentAccountId)}</Th>
              <Th>{t(messages.dcAppParentMappingUploadWarningTableError)}</Th>
            </tr>
          </thead>
          <tbody>
            {uploadResult.failedMappings.map((item, index) => (
              <tr key={`${index}-${item.appAccountId}-${item.parentAccountId ?? ''}`}>
                <Td>{item.appAccountId}</Td>
                <Td>{item.parentAccountId ?? ''}</Td>
                <Td>{item.errorMessage}</Td>
              </tr>
            ))}
          </tbody>
        </FailedMappingsTable>
        <ButtonLink onClick={onDownloadFailed}>
          {t(messages.dcAppParentMappingUploadWarningDownloadFailed)}
        </ButtonLink>
      </SectionMessage>
    </WarningWrapper>
  );
};

export default DcAppParentMappingUploadWarning;
